export class StringUtils {
    /**
     * Obtem as iniciais de uma string e devolve resultado em uppercase.
     * @param str string
     * @returns 
     */
    public static GetInitials(value) {
        if (!value) return '';

        if (typeof value === 'string' || value instanceof String) return value.match(/(^\S\S?|\b\S)?/g).join("").match(/(^\S|\S$)?/g).join("").toUpperCase();

        return value;
    }

    /**
     * Recebe como param um string e coloca em uppercase a primeira letra de cada palavra existente na string.
     * @param value string
     * @returns 
     */
    public static UppercaseWords(value): string {
        if (typeof value === 'string' || value instanceof String) return value.replace(/^(.)|\s+(.)/g, (c) => c.toUpperCase());

        return value;
    }

    /**
     * Recebe como param duas strings para comparar se o seu valor é igual.
     * A comparação vai fazer uso do metodo localeCompare com o sensitivity: 'base' como valor default.
     * @param valueA string
     * @param valueB string
     * @param sensitivity string "base" | "accent" | "case" | "variant
     * @returns 
     */
    public static AreValuesEqual(valueA: string, valueB: string, sensitivity: "base" | "accent" | "case" | "variant" = "base"): boolean {
        if (typeof valueA !== 'string' || typeof valueB !== 'string') return false;

        return valueA.localeCompare(valueB, undefined, { sensitivity: sensitivity }) === 0;
    }

    /**
     * Normaliza string removendo acentos ou outros chars especificos de linguagem.
     * @param value string
     * @returns 
     */
    public static Normalize(value): string {
        if (typeof value === 'string' || value instanceof String) return value.normalize("NFD").replace(/[\u0300-\u036f]/g, "")

        return value;
    }

    /**
     * Recebe uma string como parametro efectua trim() e remove white space duplicado.
     * @param value string to trim
     * @returns 
     */
    public static Trim(value): string {
        if (typeof value === 'string' || value instanceof String) return value.trim().replace(/\s+/g, ' ');

        return value;
    }

    /**
     * Recebe uma string como parametro e remove white todo o white space existente.
     * @param value string para remover todo o espaços
     * @returns 
     */
    public static RemoveWhiteSpace(value) {
        if (typeof value === 'string' || value instanceof String) return value.replace(/\s+/g, '');

        return value;
    }

    /**
     * pesquisa pela letra e devolve o valor do ATCUD
     * @param value 
     * @param letter 
     * @returns 
     */
    public static ATCUD(value, letter: string = ''): string {
        if ((typeof value === 'string' || value instanceof String) && letter) {

            const props = value.split('*');

            console.log(props);

            return props?.find(it => it.match(letter + ':'))?.split(':')[1];
        }

        return null;
    }

    /**
     * Remove caracteres estranhos
     * @param value 
     * @returns 
     */
    public static ATCUDEncodeFix(value: string): string {

        // verifica se não existe "Ç" primeiros chars [10]
        if (!value?.substring(0, 10).toUpperCase().includes('Ç'))
            return value;

        const replacements: { [key: string]: string } = {
            'Ç': ':',
            '(': '*',
            '\'': '-'
        };

        Object.keys(replacements).forEach(badChar => {
            const goodChar = replacements[badChar];
            value = value.split(badChar).join(goodChar);
        });

        return value;
    }


    /**
     * devolve lista do atcud por key value
     * @param value 
     * @returns 
     */
    public static ATCUDArray(value): any[] {
        if (typeof value === 'string') {

            const props = value?.split('*');

            // console.log(props);            

            return props?.map(it => { return { Key: it?.split(':')[0], Value: it?.split(':')[1] } });
        }

        return [];
    }


    /**
     * copia a string e retorna o resultado da operacao
     * @param text 
     * @returns 
     */
    public static ClipboardText(text: string = ''): boolean {
        if (!text) return false;

        try {

            navigator.clipboard.writeText(text);

            console.log("clipboard -> ", text);

            return true;

        } catch (error) {

            console.log(error);

            return false;

        }
    }

    /**
     * 
     * @param number 
     * @returns 
     */
    public static FormatToCreditCardNumber(number: string): string {
        return StringUtils.RemoveWhiteSpace(number).replace(/(.{4})/g, '$1 ').trim();
    }

    /**
     * 
     * @param date 
     * @returns 
     */
    public static FormatATCUDDate(date: string): string {

        if (!date || typeof date != 'string') return null;

        // Extract the year, month, and day from the string
        const year = StringUtils.RemoveWhiteSpace(date.substring(0, 4));
        const month = StringUtils.RemoveWhiteSpace(date.substring(4, 6));
        const day = StringUtils.RemoveWhiteSpace(date.substring(6, 8));

        // Format the date as yyyy-mm-dd
        return `${year}-${month}-${day}`;

    }

    /**
     * 
     * @param text 
     * @returns 
     */
    public static EncodeQRString(text: string): string {
        console.log(text);

        try { return btoa(text).replace('==', ''); } catch (error) { return null; }

    }

    /**
     * 
     * @param text 
     * @returns 
     */
    public static DecodeQRString(text: string): string {
        console.log(text);

        try { return atob(text); } catch (error) { return null; }
    }

    /**
     * 
     * @param fullName 
     * @param hasInitials
     * @returns 
     */
    public static FormatNameCard(fullName: string, hasInitials: boolean = false): string {

        if (!fullName) return "";
        
        let parts = fullName.trim().split(/\s+/);
        if (parts.length < 2) return fullName; // Return as is if there's no last name

        let firstName = parts[0];
        let lastName = parts[parts.length - 1];
        let initials = parts.slice(1, -1) // Middle names
            .filter(word => !["da", "de", "do", "das", "dos", "e"].includes(word.toLowerCase()))
            .map(word => word[0] + ".") // Convert to initials
            .join(" ");

        let familyNames = parts.slice(2)
            .filter(word => !["da", "de", "do", "das", "dos", "e"].includes(word.toLowerCase()))


        // Se não sobrar nada (ex: "João de"), devolve primeiro + último nome original
        if (familyNames.length === 0) {
            familyNames = [parts[parts.length - 1]];
        }

        console.log(familyNames);


        return hasInitials ? `${firstName} ${initials} ${lastName}`.trim() : `${firstName} ${familyNames.join(" ")}`.trim();
    }

    /**
     * 
     * @param name 
     * @returns 
     */
    public static FormatPersonName(name) {

        if (!name) return '';

        // Lista de partículas que devem ficar em lowercase
        const particles = ["de", "da", "das", "do", "dos", "e"];

        name = StringUtils.StripSpecialScripts(name);

        return name
            .toLowerCase()
            .split(" ")
            .map((word, index) => {
                // Se a palavra for uma partícula (e não for a primeira do nome)
                if (particles.includes(word) && index > 0) {
                    return word;
                }
                // Capitaliza a primeira letra
                return word.charAt(0).toUpperCase() + word.slice(1);
            })
            .join(" ");
    }

    /**
     * 
     * @param street 
     * @returns 
     */
    public static FormatStreetName(street) {

        if (!street) return '';

        const particles = ["de", "da", "das", "do", "dos", "e"];

        street = StringUtils.StripSpecialScripts(street);

        return street
            .toLowerCase()
            .split(" ")
            .map((word, index) => {
                // A primeira palavra é sempre capitalizada
                if (index === 0) {
                    return word.charAt(0).toUpperCase() + word.slice(1);
                }
                // Se for partícula, mantém lowercase
                if (particles.includes(word)) {
                    return word;
                }
                // Caso contrário, capitaliza
                return word.charAt(0).toUpperCase() + word.slice(1);
            })
            .join(" ");
    }

    public static StripInvisibleChars(text: string): string {
        // Lista de códigos Unicode que queremos eliminar/substituir
        const invisible =
            /[\u0000-\u0008\u000B\u000C\u000E-\u001F\u200B-\u200D\u2028\u2029\uFEFF]/g;
        // \u00A0 = &nbsp; → converte para espaço comum
        // \t → converte para espaço simples (ou pode remover, depende do caso)
        // \r → remove, pois usamos \n como separador de linha
        return text
            .replace(invisible, '')          // exclui ZWSP, ZWNJ, ZWJ, line/paragraph separators, etc.
            .replace(/\u00A0/g, ' ')         // NBSP → space
            .replace(/\t/g, ' ')             // tab → space (ou .replace(/\t/g, '') se preferir remover)
            .replace(/\r/g, '')              // CR sem LF → remove
            .replace(/\s+/g, ' ')            // colapsa múltiplos espaços em um só
            .trim();                         // remove espaços nas pontas
    }

    public static StripSpecialScripts(txt: string, replaceWith = ''): string {
        return txt.replace(/[\u2070-\u2079\u2080-\u2089\u00BA]/g, replaceWith);
    }
}



